var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map-wrapper",staticClass:"map"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(!_vm.data)?_c('div',{staticClass:"loading-map"}):_vm._e(),_c('canvas',{ref:"canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }